import React, { FC } from 'react'

export const SizeGuide: FC = () => {
  const dataItemSize = document.getElementById('collection-size-settings-json')
  const rawSize = dataItemSize !== null ? dataItemSize?.innerText : null
  const data = rawSize !== null ? JSON.parse(rawSize) : null

  if (data == null) {
    return null
  }

  return (
    <div className="AlgoliaSizeGuide">
      {data.header && (
        <div className="AlgoliaSizeGuide-header">{data.header}</div>
      )}

      {data.text && <div className="AlgoliaSizeGuide-text">{data.text}</div>}

      {data.url && data.cta && (
        <div className="AlgoliaSizeGuide-btnContainer">
          <a href={data.url}>
            <button className="o-button o-button--blue AlgoliaSizeGuide-btn">
              {data.cta}
            </button>
          </a>
        </div>
      )}
    </div>
  )
}
